import { render, staticRenderFns } from "./ElwButton.vue?vue&type=template&id=05f2c25a&"
import script from "./ElwButton.ts?vue&type=script&lang=ts&"
export * from "./ElwButton.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports